import React from 'react';

const Bard_Home = () => {
  return (
    <div>
      <h1>Bard_Home</h1>
      <p>This is the Bard_Home component.</p>
    </div>
  );
};

export default Bard_Home;
